import React, {useEffect} from 'react';
import {FormControlLabel, Checkbox, FormHelperText} from '@material-ui/core';

const CheckboxWithLabel = ({noEdit, formikProps, ...props}) => {
  const {
    values: {iD_Type, included_capa_ini},
    touched,
    setFieldValue,
    errors,
  } = formikProps;

  const errorMessage =
    touched['included_capa_ini'] && errors['included_capa_ini'];
  const handleChange = (event) => {
    const {checked} = event.target;
    setFieldValue('included_capa_ini', iD_Type === 'SOP' ? true : checked);
  };

  useEffect(() => {
    if (iD_Type === 'SOP') {
      setFieldValue('included_capa_ini', true);
    }
  }, [iD_Type, setFieldValue]);

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            checked={included_capa_ini}
            disabled={iD_Type === 'SOP'}
            onChange={handleChange}
          />
        }
        label={props.Label.label}
        disabled={noEdit}
        error={Boolean(errorMessage)}
        helperText={errorMessage}
      />
      {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
    </>
  );
};

export default CheckboxWithLabel;
